import { DS_BUTTON_VARIANT } from "@/src/design_system/button_and_controls/button/types/props";
import type { DSButtonSize } from "@/src/design_system/button_and_controls/button/types/props";
import type { DSSizingProps } from "@/src/design_system/shared/types/props";
import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_DRAG_HANDLE_VARIANT = {
  Secondary: DS_BUTTON_VARIANT.Secondary,
  Tertiary: DS_BUTTON_VARIANT.Tertiary,
  Ghost: DS_BUTTON_VARIANT.Ghost,
} as const;

export type DSDragHandleVariant = ObjectValues<typeof DS_DRAG_HANDLE_VARIANT>;

export interface DSDragHandleProps extends DSSizingProps<DSButtonSize> {
  ariaLabel?: string;
  disabled?: boolean;
  variant?: DSDragHandleVariant;
}
